import { tokenAl } from './authApi';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

function yetkiliBaslik() {
  return {
    Authorization: 'Bearer ' + tokenAl(),
    'Content-Type': 'application/json'
  };
}

export async function hesabimGetir() {
  const response = await fetch(`${API_BASE}/api/auth/me`, { headers: yetkiliBaslik() });
  const veri = await response.json();

  if (!response.ok) {
    throw new Error(veri.error || 'Hesap bilgisi alınamadı');
  }

  return { email: veri.email, bakiye: Number(veri.bakiye) };
}

export async function paraYatirmalariGetir() {
  const response = await fetch(`${API_BASE}/api/para-yatirma`, { headers: yetkiliBaslik() });
  const veri = await response.json();

  if (!response.ok) {
    throw new Error(veri.error || 'Para yatırma geçmişi alınamadı');
  }

  return veri.yatirmalar;
}

export async function paraYatir(tutar) {
  const response = await fetch(`${API_BASE}/api/para-yatirma`, {
    method: 'POST',
    headers: yetkiliBaslik(),
    body: JSON.stringify({ tutar })
  });

  const veri = await response.json();

  if (!response.ok) {
    throw new Error(veri.error || 'Para yatırma işlemi kaydedilemedi');
  }

  return { id: veri.id, tutar: veri.tutar, bakiye: Number(veri.bakiye) };
}

export async function paraCekmeleriGetir() {
  const response = await fetch(`${API_BASE}/api/para-cekme`, { headers: yetkiliBaslik() });
  const veri = await response.json();

  if (!response.ok) {
    throw new Error(veri.error || 'Para çekme geçmişi alınamadı');
  }

  return veri.cekmeler;
}

export async function paraCek(tutar) {
  const response = await fetch(`${API_BASE}/api/para-cekme`, {
    method: 'POST',
    headers: yetkiliBaslik(),
    body: JSON.stringify({ tutar })
  });

  const veri = await response.json();

  if (!response.ok) {
    throw new Error(veri.error || 'Para çekme işlemi kaydedilemedi');
  }

  return { id: veri.id, tutar: veri.tutar, bakiye: Number(veri.bakiye) };
}

export async function toplamMasrafGetir() {
  const response = await fetch(`${API_BASE}/api/masraflar/toplam`, { headers: yetkiliBaslik() });
  const veri = await response.json();

  if (!response.ok) {
    throw new Error(veri.error || 'Toplam masraf alınamadı');
  }

  return Number(veri.toplam);
}

// Bakiye, başka bir sekmede yapılan para yatırma/alım/satım işlemleri
// dahil her değiştiğinde anında yansısın diye SSE akışına (server/index.js:
// /api/hesap-stream) abone olunur. EventSource özel header gönderemediği
// için token query string üzerinden veriliyor (bkz. server/auth.js).
export function bakiyeAkisiAc(bakiyeGuncellendi) {
  const kaynak = new EventSource(`${API_BASE}/api/hesap-stream?token=${encodeURIComponent(tokenAl())}`);

  kaynak.addEventListener('bakiye', event => {
    const veri = JSON.parse(event.data);
    bakiyeGuncellendi(Number(veri.bakiye));
  });

  return () => kaynak.close();
}
